import { useEffect, useState } from "react";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminInbox from "@/components/admin/AdminInbox";
import { getToken, adminMe, clearToken } from "@/lib/admin";

export default function AdminPage() {
    const [authed, setAuthed] = useState(null);

    useEffect(() => {
        document.title = "Order Inbox · Annabells Cupcakes and More";
        if (!getToken()) return setAuthed(false);
        adminMe().then(() => setAuthed(true)).catch(() => { clearToken(); setAuthed(false); });
    }, []);

    if (authed === null) return <div className="min-h-screen bg-[#3D2318]" data-testid="admin-loading" />;
    return authed ? <AdminInbox onLogout={() => setAuthed(false)} /> : <AdminLogin onSuccess={() => setAuthed(true)} />;
}
